export class Sede {

    public uuid: string;
    public denominazione: string;
    public descrizione: string;
    public indirizzo: string;
    public contatti: string;
    public paese: string;
    public latitudine: number;
    public longitudine: number;
    public lang: string;
    public email: string;
    public website: string;

    constructor() {
    }
}
